/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const MailRequirementSetting = createEnum('MAIL_REQUIREMENT_SETTING', {
  NotRequired: 'NOT_REQUIRED',
  ShowWarning: 'SHOW_WARNING',
  ShowError: 'SHOW_ERROR',
});

export type MailRequirementSetting = EnumSet<typeof MailRequirementSetting>;
